import { Injectable } from '@angular/core';
import { Observable, SubscribableOrPromise } from 'rxjs';

import { AngularFireDatabase, AngularFireList } from '@angular/fire/database';
import 'rxjs/add/operator/map';
import { TabRoomData } from '../components/tabs/models/tab-room.model';

@Injectable()
export class HubService {
  hubRoomsRef: AngularFireList<any>;
  hubRooms: Observable<any[]>;

  hub;

  constructor(public afd: AngularFireDatabase) {
    this.hubRoomsRef = afd.list('hub');
    this.hubRooms = this.hubRoomsRef.snapshotChanges().map(changes => {
      return changes.map(c => ({ key: c.payload.key, ...c.payload.val() }));
    });
  }

  addHub(user) {
    const genericHubData = {
      tabKey: 'playNow',
      roomName: 'Room' + Math.floor(Math.random() * Math.floor(5000)),
      nbPlayers: 1,
      createdAt: new Date() + '',
      players: [
        {
          displayName: user.displayName,
          roles: ['host', 'player'],
          img: user.photoURL ? user.photoURL : null,
          uid: user.uid
        }
      ]
    };

    // default data to GUI select
    // todo move into room creation part
    /* const specificHubData = {
      boss: "RHINO", // roomcreactionComponent.bosses[0].targetname
      bossLevel: "hard",
      encounterNumber: 2 // roomcreactionComponent.min encounteer value
      // roomId: '-M8ggOzhukK9YPxVTpPJ',
    }; */

    const defaultData: any = { // :TabRoomData
      ...genericHubData
      // ...specificHubData
    };
    this.hubRoomsRef.set(user.uid, defaultData);
    return defaultData;
    // return this.afd.object(`/hub/${user.uid}`).set(defaultData);
  }

  deleteHub(hubId) {
    return this.afd.object(`hub/${hubId}`).remove();
  }

  updateHub(roomId, data): SubscribableOrPromise<any> {
    return this.hubRoomsRef.set(roomId, data).then(res => {
      // this.lockBoard = false;
    });
  }

  updateHubPart(roomId, key, data) {
    return this.hubRoomsRef.set(`${roomId}/${key}`, data);
  }
}
